import React, {useEffect, useState} from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, Stack, Step, StepLabel, Stepper} from "@mui/material";
import {Box} from "@mui/system";
import TextFieldValidation from "../table/customer-detales/TextFieldValidation";
import ButtonBack from "../button/ButtonBack";
import ButtonExit from "../button/ButtonExit";
import ButtonAdd from "../button/ButtonAdd";
import MaterialWarehouseService from "../../../API/orders/warehouse/material/MaterialWarehouseService";
import WarehouseMaterialItemTable from "../table/warehouse/material/materialwarehouse/WarehouseMaterialItemTable";
import UtilityService from "../../../API/common/UtilityService";

const ModalIssuing = ({
                          open,
                          onClose,
                          title,
                          initValues,
                          handleSubmit,
                          handleModalAlert,
                          loading
                      }) => {
    const [currencies, setCurrencies] = useState()
    const [currencyMap, setCurrencyMap] = useState(new Map);
    const [activeStep, setActiveStep] = useState(0)
    const [materialWarehouse, setMaterialWarehouse] = useState(null)
    const [values, setValues] = useState({issue: ""})
    const [validationState, setValidationState] = useState({issue: ""})
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 20,
        totalElements: 0,
        searchData: ""
    })

    const tableOptionsHandle = (nextState, currTab) => {
        setTableOptions(nextState)
    }

    useEffect(() => {
        UtilityService.getCurrencies()
            .then(function (response) {
                const data = response.data;
                data.forEach((c) => {
                    currencyMap.set(c.id, c);
                });
                setCurrencies(data)
            }).catch(function (error) {
            handleModalAlert(error)
        })
    }, [initValues]);

    const close = () => {
        onClose()
        setActiveStep(0)
        setValues({issue: ""})
        setMaterialWarehouse(null)
        setValidationState({issue: ""})
    }
    const submit = () => {
        if (activeStep === 0) {
            setActiveStep(1)
        } else {
            const newErrors = {...validationState}

            Object.entries(values).forEach(([name, value]) => {
                if (value === "") {
                    newErrors[name] = "пустое поле"
                } else if (Number(value) > Number(initValues?.quantity)) {
                    newErrors[name] = `Не должно быть больше чем остаток на складе (${initValues?.quantity})`
                }
            })

            setValidationState(newErrors)

            if (Object.values(newErrors).every(el => el === "")) {
                handleSubmit(values.issue, materialWarehouse.id, close)
            }
        }
    }

    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: `${activeStep === 0 ? "1000px" : "800px"}`,
            }
        }}>
            <DialogTitle textAlign="center">{title}</DialogTitle>
            <Box sx={{display: "flex", justifyContent: "center"}}>
                <Stepper
                    style={{width: 700}}
                    activeStep={activeStep}
                >
                    {["Выбрать остаток на складе", "Выдать материал в количестве"].map((label) => (
                        <Step key={label}>
                            <StepLabel sx={{
                                ".MuiSvgIcon-root": {
                                    fontSize: 40,
                                    color: "#737478",
                                    "&.Mui-active": {
                                        color: "#3B8BEC",
                                    }
                                },
                                "& .MuiStepLabel-label": {
                                    fontSize: 18,
                                    "&.Mui-active": {
                                        fontWeight: 700,
                                    }
                                }
                            }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Box>
            <DialogContent>
                {(activeStep === 0) ?
                    <WarehouseMaterialItemTable
                        getAll={MaterialWarehouseService.getAllByMaterialId}
                        id={initValues?.materialId}
                        currencyMap={currencyMap}
                        currencies={currencies}
                        handleModalAlert={handleModalAlert}
                        tableOptions={tableOptions}
                        tableOptionsHandle={tableOptionsHandle}
                        baseUnit={"м"}
                        isModal={true}
                        selectedString={materialWarehouse}
                        setSelectedString={setMaterialWarehouse}
                    />
                    :
                    <TextFieldValidation
                        name={"issue"}
                        type={"number"}
                        value={values?.issue}
                        label={"Количество"}
                        setCurrValues={setValues}
                        validationError={validationState?.issue}
                        setValidationState={setValidationState}
                    />
                }
            </DialogContent>
            <DialogActions style={{padding: 40, display: "flex", justifyContent: "space-between"}}>
                <Box>{activeStep !== 0 && <ButtonBack text={"Назад"} onClick={() => setActiveStep(0)}/>} </Box>
                <Box>
                    <ButtonExit
                        text={"Выйти"} onClick={close}/>
                    <ButtonAdd
                        loading={loading}
                        text={(activeStep === 0) ? "Выбрать" : "Выдать"}
                        onClick={submit}
                        disabled={!materialWarehouse}
                    />
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default ModalIssuing;